import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\ApiManagementController::revokeKey
* @see app/Http/Controllers/Admin/ApiManagementController.php:85
* @route '/app/admin/api-management/keys/{apiKey}/revoke'
*/
export const revokeKey = (args: { apiKey: number | { id: number } } | [apiKey: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: revokeKey.url(args, options),
    method: 'put',
})

revokeKey.definition = {
    methods: ["put"],
    url: '/app/admin/api-management/keys/{apiKey}/revoke',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\ApiManagementController::revokeKey
* @see app/Http/Controllers/Admin/ApiManagementController.php:85
* @route '/app/admin/api-management/keys/{apiKey}/revoke'
*/
revokeKey.url = (args: { apiKey: number | { id: number } } | [apiKey: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { apiKey: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { apiKey: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            apiKey: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        apiKey: typeof args.apiKey === 'object'
        ? args.apiKey.id
        : args.apiKey,
    }

    return revokeKey.definition.url
            .replace('{apiKey}', parsedArgs.apiKey.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ApiManagementController::revokeKey
* @see app/Http/Controllers/Admin/ApiManagementController.php:85
* @route '/app/admin/api-management/keys/{apiKey}/revoke'
*/
revokeKey.put = (args: { apiKey: number | { id: number } } | [apiKey: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: revokeKey.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\ApiManagementController::revokeKey
* @see app/Http/Controllers/Admin/ApiManagementController.php:85
* @route '/app/admin/api-management/keys/{apiKey}/revoke'
*/
const revokeKeyForm = (args: { apiKey: number | { id: number } } | [apiKey: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: revokeKey.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\ApiManagementController::revokeKey
* @see app/Http/Controllers/Admin/ApiManagementController.php:85
* @route '/app/admin/api-management/keys/{apiKey}/revoke'
*/
revokeKeyForm.put = (args: { apiKey: number | { id: number } } | [apiKey: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: revokeKey.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

revokeKey.form = revokeKeyForm

/**
* @see \App\Http\Controllers\Admin\ApiManagementController::blockIp
* @see app/Http/Controllers/Admin/ApiManagementController.php:102
* @route '/app/admin/api-management/blacklist'
*/
export const blockIp = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: blockIp.url(options),
    method: 'post',
})

blockIp.definition = {
    methods: ["post"],
    url: '/app/admin/api-management/blacklist',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\ApiManagementController::blockIp
* @see app/Http/Controllers/Admin/ApiManagementController.php:102
* @route '/app/admin/api-management/blacklist'
*/
blockIp.url = (options?: RouteQueryOptions) => {
    return blockIp.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ApiManagementController::blockIp
* @see app/Http/Controllers/Admin/ApiManagementController.php:102
* @route '/app/admin/api-management/blacklist'
*/
blockIp.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: blockIp.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\ApiManagementController::blockIp
* @see app/Http/Controllers/Admin/ApiManagementController.php:102
* @route '/app/admin/api-management/blacklist'
*/
const blockIpForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: blockIp.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\ApiManagementController::blockIp
* @see app/Http/Controllers/Admin/ApiManagementController.php:102
* @route '/app/admin/api-management/blacklist'
*/
blockIpForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: blockIp.url(options),
    method: 'post',
})

blockIp.form = blockIpForm

/**
* @see \App\Http\Controllers\Admin\ApiManagementController::unblockIp
* @see app/Http/Controllers/Admin/ApiManagementController.php:130
* @route '/app/admin/api-management/blacklist/{apiIpBlacklist}'
*/
export const unblockIp = (args: { apiIpBlacklist: number | { id: number } } | [apiIpBlacklist: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: unblockIp.url(args, options),
    method: 'delete',
})

unblockIp.definition = {
    methods: ["delete"],
    url: '/app/admin/api-management/blacklist/{apiIpBlacklist}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Admin\ApiManagementController::unblockIp
* @see app/Http/Controllers/Admin/ApiManagementController.php:130
* @route '/app/admin/api-management/blacklist/{apiIpBlacklist}'
*/
unblockIp.url = (args: { apiIpBlacklist: number | { id: number } } | [apiIpBlacklist: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { apiIpBlacklist: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { apiIpBlacklist: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            apiIpBlacklist: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        apiIpBlacklist: typeof args.apiIpBlacklist === 'object'
        ? args.apiIpBlacklist.id
        : args.apiIpBlacklist,
    }

    return unblockIp.definition.url
            .replace('{apiIpBlacklist}', parsedArgs.apiIpBlacklist.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ApiManagementController::unblockIp
* @see app/Http/Controllers/Admin/ApiManagementController.php:130
* @route '/app/admin/api-management/blacklist/{apiIpBlacklist}'
*/
unblockIp.delete = (args: { apiIpBlacklist: number | { id: number } } | [apiIpBlacklist: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: unblockIp.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Admin\ApiManagementController::unblockIp
* @see app/Http/Controllers/Admin/ApiManagementController.php:130
* @route '/app/admin/api-management/blacklist/{apiIpBlacklist}'
*/
const unblockIpForm = (args: { apiIpBlacklist: number | { id: number } } | [apiIpBlacklist: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: unblockIp.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\ApiManagementController::unblockIp
* @see app/Http/Controllers/Admin/ApiManagementController.php:130
* @route '/app/admin/api-management/blacklist/{apiIpBlacklist}'
*/
unblockIpForm.delete = (args: { apiIpBlacklist: number | { id: number } } | [apiIpBlacklist: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: unblockIp.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

unblockIp.form = unblockIpForm

/**
* @see \App\Http\Controllers\Admin\ApiManagementController::deleteWebhook
* @see app/Http/Controllers/Admin/ApiManagementController.php:150
* @route '/app/admin/api-management/webhooks/{webhook}'
*/
export const deleteWebhook = (args: { webhook: number | { id: number } } | [webhook: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteWebhook.url(args, options),
    method: 'delete',
})

deleteWebhook.definition = {
    methods: ["delete"],
    url: '/app/admin/api-management/webhooks/{webhook}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Admin\ApiManagementController::deleteWebhook
* @see app/Http/Controllers/Admin/ApiManagementController.php:150
* @route '/app/admin/api-management/webhooks/{webhook}'
*/
deleteWebhook.url = (args: { webhook: number | { id: number } } | [webhook: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { webhook: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { webhook: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            webhook: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        webhook: typeof args.webhook === 'object'
        ? args.webhook.id
        : args.webhook,
    }

    return deleteWebhook.definition.url
            .replace('{webhook}', parsedArgs.webhook.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ApiManagementController::deleteWebhook
* @see app/Http/Controllers/Admin/ApiManagementController.php:150
* @route '/app/admin/api-management/webhooks/{webhook}'
*/
deleteWebhook.delete = (args: { webhook: number | { id: number } } | [webhook: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteWebhook.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Admin\ApiManagementController::deleteWebhook
* @see app/Http/Controllers/Admin/ApiManagementController.php:150
* @route '/app/admin/api-management/webhooks/{webhook}'
*/
const deleteWebhookForm = (args: { webhook: number | { id: number } } | [webhook: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: deleteWebhook.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\ApiManagementController::deleteWebhook
* @see app/Http/Controllers/Admin/ApiManagementController.php:150
* @route '/app/admin/api-management/webhooks/{webhook}'
*/
deleteWebhookForm.delete = (args: { webhook: number | { id: number } } | [webhook: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: deleteWebhook.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

deleteWebhook.form = deleteWebhookForm

const apiManagement = {
    revokeKey: Object.assign(revokeKey, revokeKey),
    blockIp: Object.assign(blockIp, blockIp),
    unblockIp: Object.assign(unblockIp, unblockIp),
    deleteWebhook: Object.assign(deleteWebhook, deleteWebhook),
}

export default apiManagement